require('../services/auth-service.js');
require('../controllers/auth-ctrl.js');
angular.element(function() {
    angular.bootstrap(document, ['appMarketplace']);
});


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/page-entries/auth-entry.js
// module id = 484
// module chunks = 36